import React, { createContext, useContext, useRef } from 'react';
const defaultLogoutContext = {
    logout: { current: () => void 0 },
    setLogout: () => void 0,
};
export const LogoutContext = createContext(defaultLogoutContext);
export const useLogoutContext = () => useContext(LogoutContext);
export const LogoutContextProvider = ({ children, }) => {
    const logout = useRef(() => {
        console.log('Initial _logout function');
    });
    const setLogout = (fn) => {
        logout.current = fn;
    };
    return (React.createElement(LogoutContext.Provider, { value: { logout, setLogout } }, children));
};
